import { render } from "./FavoriteEditionForm.vue?vue&type=template&id=9a6b8af0&scoped=true"
import script from "./FavoriteEditionForm.vue?vue&type=script&lang=js"
export * from "./FavoriteEditionForm.vue?vue&type=script&lang=js"

import "./FavoriteEditionForm.vue?vue&type=style&index=0&id=9a6b8af0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a6b8af0"]])

export default __exports__